import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showShareCohort } from '../actions';

const ShareCohortAction = ({
  category,
  code,
  readErrors,
  share,
  secureOnly,
  disabled,
}) => (
  <RibbonMenu
    name="share"
    icon={secureOnly ? 'shield' : 'share alternate'}
    message={secureOnly ? 'actions.security' : 'actions.share'}
    onClick={() => share(category, code)}
    className="aridhia-share-cohort-action"
    disabled={firstError(readErrors) !== null || disabled}
  />
);

const mapStateToProps = ({
  cohorts: { cohorts },
}, { category, code }) => {
  const cohort = findResult(cohorts, category, code);

  return {
    readErrors: cohort ? cohort.readErrors : [],
  };
};

const mapDispatchToProps = {
  share: showShareCohort,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareCohortAction);
